import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  signal,
  WritableSignal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject } from 'rxjs';

import { IconComponent } from '@shared/components/icon/icon.component';
import { QuarterCloseNotesQuery } from '@shared/store/quarter-close-notes/quarter-close-notes.query';
import { Workflow } from '@shared/store/workflow/workflow.store';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, AsyncPipe],
  selector: 'aux-monthly-review-notes-counter',
  templateUrl: './monthly-review-notes-counter.component.html',
})
export class MonthlyReviewNotesCounterComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly quarterCloseNotesQuery = inject(QuarterCloseNotesQuery);

  private workflow: WritableSignal<null | undefined | Workflow> = signal(null);

  readonly monthlyReviewCount = computed(() => {
    if (!this.workflow()) {
      return 0;
    }

    return this.quarterCloseNotesQuery.notes()[(this.workflow() as Workflow).id]
      .monthlyReviewNotesCount;
  });

  @Output() clicked = new EventEmitter<void>();
  @Input() opened$ = new BehaviorSubject<boolean>(true);
  @Input() workflow$!: BehaviorSubject<null | Workflow>;

  ngOnInit() {
    this.workflow$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((workflow) => this.workflow.set(workflow));
  }
}
